import React from 'react'

const defaultValue = {
  locale: 'en',
  userLoggedIn: false,
  cgdreamOrigin: false,
  pageConfigLoaded: false,
  extractingCoreStyles: false,
  dccSoftwares: [],
  showGenerationErrorDetails: false,
  modelReadyToasterEnabled: false,
  segmentationFlowEnabled: false,
  enableHunyuanSegmentation: false,
  enableMeshyRemesh: false,
  enableAnimation: false,
  enableExtraQuality: false,
  enable2dRender: false,
  designerAssistEnabled: false,
  modelPickerEnabled: false,
  treeViewEnabled: false,
  ideationFlowEnabled: false,
  twoDImagesIdeationFlowEnabled: false,
  unfinishedTwoDFeaturesEnabled: false,
  imageSearchOnIdeationFLowEnabled: false,
  multiViewEnabled: false,
  communityGalleryFilterOptions: {
    visibleCategories: [],
    sortOptions: [],
  },
  communityGalleryInitialModels: null,
}

const ThreeDStudioPageContext = React.createContext(defaultValue)

export default ThreeDStudioPageContext
